function createActionTypes(namespace, actionTypes) {
  if (typeof namespace !== 'string') throw new Error('The first argument (namespace) must be a string');
  if (!Array.isArray(actionTypes)) throw new Error('The second argument (actionTypes) must be an array');

  return actionTypes.reduce((map, type) => {
    map[type] = namespace + '::' + type;
    return map;
  }, {});
}

module.exports = {
  createActionTypes: createActionTypes
};
